import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "article second" }
const _hoisted_2 = { class: "appview second container" }
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 0,
  class: "loading",
  width: "48",
  height: "48",
  viewBox: "0 0 12.7 12.7",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("linearGradient", {
    id: "a",
    x1: ".014",
    x2: "10.582",
    y1: ".035",
    y2: "10.411",
    gradientUnits: "userSpaceOnUse"
  }, [
    /*#__PURE__*/_createElementVNode("stop", {
      "stop-color": "#6dfdcc",
      offset: "0"
    }),
    /*#__PURE__*/_createElementVNode("stop", {
      "stop-color": "#6dfdcc",
      "stop-opacity": "0",
      offset: "1"
    })
  ])
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("ellipse", {
  cx: "6.35",
  cy: "6.35",
  rx: "5.645",
  ry: "5.252",
  fill: "none",
  stroke: "url(#a)",
  "stroke-dasharray": "2.132, 1.066, 0.533, 1.066",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": ".533",
  style: {"mix-blend-mode":"normal"}
}, null, -1)
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = { class: "section second" }
const _hoisted_9 = { class: "header h3" }
const _hoisted_10 = { class: "second paragraph" }
const _hoisted_11 = { class: "p first" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("img", {
        alt: "invested app challenges view",
        class: _normalizeClass(["second appview", { notLoaded: !_ctx.loaded }]),
        src: _ctx.portfolio,
        onLoad: _cache[0] || (_cache[0] = ($event: any) => (_ctx.loaded = true))
      }, null, 42, _hoisted_3),
      (!_ctx.loaded)
        ? (_openBlock(), _createElementBlock("svg", _hoisted_4, _hoisted_7))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("section", _hoisted_8, [
      _createElementVNode("h3", _hoisted_9, _toDisplayString(_ctx.t('second-header')), 1),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.t('second-paragraph')), 1)
      ])
    ])
  ]))
}